import clsx from 'clsx';
import { generateTestId } from './data';
import { Link } from 'react-router-dom';
export interface SidebarItemProps {
  dataTestId: string;
  label: string;
  url: string;
  Icon?: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  isActive?: boolean;
  isSidebarOpen?: boolean;
  action?: () => void;
  hasBorder?: boolean;
}

const SidebarItem = (props: SidebarItemProps) => {
  const { label, isActive, url, Icon, isSidebarOpen, dataTestId, action, hasBorder } = props;

  const testIds = generateTestId(dataTestId);

  return (
    <Link
      data-testid={testIds.component}
      to={url}
      onClick={action}
      className={clsx(
        'flex items-center w-full p-3 my-2 rounded transition leading-none duration-200 text-gray-500 hover:bg-primary-50 hover:text-primary-500',
        {
          'bg-primary-50 text-primary-500': isActive,
          border: hasBorder,
        },
      )}
    >
      {Icon && (
        <div className='flex'>
          <Icon className={`${isActive ? 'text-primary-500' : 'text-gray-500'} text-current w-5 h-5 `} />
        </div>
      )}
      <span className={`ml-4 ${!isSidebarOpen && 'hidden'}`}>{label}</span>
    </Link>
  );
};

export default SidebarItem;
